import { TemplatePage } from './types';

const facebookPage: TemplatePage = {
  header: {
    color: '#81DAEA',
    icon: 'images/video-templates/facebook-video.jpg',
    title: 'Facebook Video Templates Collection',
    title_meta: '400+ Editable and Free Facebook Video Templates',
    description_meta:
      'Create thumb-stopping videos for your audience on social media with Wave.video’s collection of 400+ easy-to-edit ' +
      'Facebook video templates.',
    description:
      'Create thumb-stopping videos for your audience on social media with this collection of 400+ easy-to-edit Facebook ' +
      'video templates. Customize templates to fit your brand and share them on your Facebook Page easily.'
  },
  footer: {
    category: 'Facebook',
    description:
      'With Wave.video’s editable Facebook video templates, you won’t need to spend a fortune on creating engaging and ' +
      'professional-looking videos. Choose a template that suits your goals best, customize it to your branding, and download ' +
      'or publish it on your page right away. Creating videos for Facebook has never been easier!'
  },
  content: [
    {
      type: 'templates',
      title: 'Facebook video',
      search: { price_min: '0', name: 'facebook' }
    },
    {
      type: 'stocks',
      title: 'facebook',
      search: { name: 'facebook' }
    },
    { type: 'calendar' }
  ]
};

export default facebookPage;
